var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path, _rect12, _rect13, _rect14, _rect15, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 88,
    viewBox: "0 0 150 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 87,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 87,
    rx: 5.5,
    stroke: "#030F23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 116.618,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21.8105,
    width: 99.6819,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27.6201,
    width: 116.618,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33.4307,
    width: 36.9984,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8086,
    y: 33.4307,
    width: 36.9984,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6172,
    y: 33.4307,
    width: 36.9984,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 46.207,
    width: 116.618,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 52.0176,
    width: 114.51,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 57.8271,
    width: 76.5734,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 63.6377,
    width: 116.618,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 69.4473,
    width: 99.6819,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 51C61 48.2386 63.2386 46 66 46C68.7614 46 71 48.2386 71 51C71 53.7614 68.7614 56 66 56H61.625C61.2798 56 61 55.7202 61 55.375V51Z",
    fill: "#12ABBF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 46,
    width: 52,
    height: 31,
    rx: 2,
    fill: "#030F23"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 49,
    width: 41,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 54,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 59,
    width: 42,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 70,
    r: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 72V68M119 68L118 69M119 68L120 69",
    stroke: "#030F23",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightItem);
export default __webpack_public_path__ + "static/media/right-item.1ead6fb8f443535dfa5f5ede890cf468.svg";
export { ForwardRef as ReactComponent };